import React, { useState } from 'react';
import { Select } from '../../../../components';
import {
  CompensationFileUpload,
  HandleApplicationFee,
  HandleGPARule,
  HandleOfferManagement,
  HandleRefereeReport,
} from './AdhocTools';

export const AdhocHomePage = (): React.JSX.Element => {
  const [activatedId, setActivatedId] = useState<string>('-- Please Choose --');

  const functionMap: Record<
    string,
    {
      element: React.ReactNode;
      note?: string;
    }
  > = {
    '-- Please Choose --': {
      element: (
        <div>
          <p>Please select.</p>
        </div>
      ),
      note: '',
    },
    'Upload File': {
      element: <CompensationFileUpload />,
      note: 'This page is for ad-hoc file uploading in case there is a loss of files. Operator should copy the file key in the early October.',
    },
    'Referee Report': {
      element: <HandleRefereeReport />,
      note: 'This page supports regeneration of referee reports, and upload the referee report from other places.',
    },
    'Application Fee': {
      element: <HandleApplicationFee />,
      note: 'This page supports manual update of application fee deadline.',
    },
    'GPA Converter Rule': {
      element: <HandleGPARule />,
      note: 'This page supports manual creation of GPA converter rule.',
    },
    'Offer Management': {
      element: <HandleOfferManagement />,
      note: 'This page supports manual modification of offer holders.',
    },
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setActivatedId(event.target.value);
  };
  const options = Object.keys(functionMap).map((key: string) => ({
    label: key,
    value: key,
  }));

  const { note, element } = functionMap[activatedId];

  return (
    <>
      <div className="pl-2 pr-2 w-[80%]">
        <div className="h-[120px]">
          <div className="w-[240px]">
            <Select
              options={options}
              value={activatedId}
              onChange={handleChange}
              label={'Select Function'}
              fullWidth
            />
          </div>
          {note && (
            <div>
              <p className="m-4">{note}</p>
            </div>
          )}
        </div>
        <div>{element}</div>
      </div>
    </>
  );
};
